import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Layout } from "@/components/Layout";
import { RulesManager } from "@/components/buildRule/RulesManager";
import { RuleVersionHistory } from "@/components/VersionRule/RuleVersionHistory";
import { SearchResolve } from "@/components/SearchResolve";
import { DataQuality } from "@/components/DataQuality";
import { ImportExport } from "@/components/ImportExport";
import { AuditLog } from "@/components/AuditLog";
import { AIConsole } from "@/components/AIConsole";
import { Settings } from "@/components/Settings";
import NotFound from "@/pages/not-found";
import EdiTableRuleBuilder from "./components/buildRule/CreateRule";
import ModifyValue from "./components/VersionRule/ModifyValue";
import { RulesFunction } from "./components/FunctionRule/RulesFunction";
import { CreatePublishRule } from "./components/PublishRule/CreatePublishRule";
import CreateRulePrompt from "./components/AIBuilder/CreateRulePrompt";
import { useAuthMe } from "./hooks/useLocalStorage";
import { useEffect } from "react";
import { RedirectingScreen } from "./components/authentication/LoadingSpinner";
import { PortalForms } from "./components/FormDesigner/PortalForms";
import { WorkflowForms } from "./components/FormDesigner/WorkflowForms";
import { PartnerForms } from "./components/FormDesigner/PartnerForms";


function Router() {
  return (
    <Layout>
      <Switch>
        {/* <Route path="/" component={RulesManager} /> */}
        {/* <Route path="/rulefunction" component={RulesFunction} /> */}
        <Route path="/">
          <PortalForms fromType="PortalForm" />
        </Route>
        <Route path="/workflowForms">
          <PortalForms fromType="WorkflowForm" />
        </Route>
        <Route path="/partnerWorkflowForm">
          <PortalForms fromType="PartnerForm" />
        </Route>
        <Route path="/adhocForm">
          <PortalForms fromType="AdhocForm" />
        </Route>
        <Route path="/libraryForm">
          <PortalForms fromType="LibraryForm" />
        </Route>
        <Route path="/libraryForm">
          <PortalForms fromType="LibraryForm" />
        </Route>
        <Route path="/lettertemplate">
          <PortalForms fromType="LetterTemplate" />
        </Route>
        <Route path="/emailtemplate">
          <PortalForms fromType="EmailTemplate" />
        </Route>
        <Route path="/surveytemplate">
          <PortalForms fromType="SurveyTemplate" />
        </Route>
        <Route path="ruleversion/:ruleId/:name" component={RuleVersionHistory} />
        {/* <Route path="/workflowForms" component={WorkflowForms} /> */}
        {/* <Route path="/rulepublish" component={CreatePublishRule} /> */}
        {/* <Route path="/rules/edit/:ruleId" component={EdiTableRuleBuilder} /> */}
        {/* <Route path="/version/edit/:ruleId" component={ModifyValue} /> */}
        {/* <Route path="/search" component={SearchResolve} /> */}
        {/* <Route path="/quality" component={DataQuality} /> */}
        {/* <Route path="/import" component={ImportExport} /> */}
        {/* <Route path="/audit" component={AuditLog} /> */}
        {/* <Route path="/ai-builder" component={CreateRulePrompt} /> */}
        {/* <Route path="/ai" component={AIConsole} /> */}
        {/* <Route path="/settings" component={Settings} /> */}
        <Route component={NotFound} />
      </Switch>
    </Layout>
  );
}

function AuthGuard({ children }: { children: React.ReactNode }) {
  const { data, isLoading, isError } = useAuthMe();

  useEffect(() => {
    if (isError) {
      console.log("Authentication check failed");
    }
  }, [isError]);

  // if (isLoading) {
  //   return (
  //     <div className="flex items-center justify-center min-h-screen">
  //       <div className="text-center">
  //         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
  //         <p className="text-muted-foreground">redirecting...</p>
  //       </div>
  //     </div>
  //   );
  // }

  // if (isError || !data) {
  //   return <RedirectingScreen />;
  // }

  return <>{children}</>;
}

function App() {
  useAuthMe();
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <AuthGuard>
          <Router />
        </AuthGuard>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
